import Pill from "components/Pill/PillElement";
import React from "react";

interface Props {
  lifeCycle: server.dto.ExtractorSessionLifeCycles
};

const ExtractorSessionLifeCyclePill = (props: Props) => {
  if (props.lifeCycle === "waitingForProcessing") {
    return null;
  }

  if (props.lifeCycle === "finished") {
    return <Pill color="green" label="Done" />;
  }

  if (props.lifeCycle === "fatalError") {
    return <Pill color="pink" label="Process error" />;
  }

  if (props.lifeCycle === "waitingForUserAction") {
    return <Pill color="blue" label="Awaiting input" />;
  }

  return <Pill color="transparent" label="Processing..." />;
}

export default ExtractorSessionLifeCyclePill;